'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _CloseButton = require('./CloseButton.scss');var _CloseButton2 = _interopRequireDefault(_CloseButton);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CloseButton = function CloseButton(_ref) {var _cx;var onClose = _ref.onClose,title = _ref.title,isMobile = _ref.isMobile;return (
    _react2.default.createElement('button', { className: (0, _classnames2.default)(_CloseButton2.default.btnWrapper, (_cx = {}, _cx[_CloseButton2.default.mobile] = isMobile, _cx)), onClick: onClose, title: title },
      _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-close', _CloseButton2.default.closeBtn) })));};



CloseButton.propTypes = {
  onClose: _propTypes2.default.func,
  title: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };exports.default =


CloseButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseButton/CloseButton.js
// module id = 2623
// module chunks = 0